import axios, { AxiosResponse } from "axios";
import { appConfig } from "../config/keycloak";

/**
 * Service to handle Offers operations for magic link flow
 */
class OffersService {
    private readonly api = axios.create({
        baseURL: appConfig.baseUrl
    });

    constructor() {
        // Empty constructor, configuration is in the api instance
    }

    /**
     * Exchange magic token for access token and session
     */
    public exchangeMagicToken(
        magicToken: string
    ): Promise<AxiosResponse<any>> {
        return this.api.post(
            `/deal-service/api/public/exchange-magic`,
            { token: magicToken },
            { 
                headers: { 
                    'Content-Type': 'application/json'
                } 
            }
        );
    }

    /**
     * Get deals by link using access token and session
     */
    public getDealsByLink(
        accessToken: string,
        sessionId: string,
        idempotencyKey: string = `offers-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`
    ): Promise<AxiosResponse<any>> {
        return this.api.get(
            `/deal-service/api/deals/by-link`,
            { 
                headers: { 
                    'Authorization': `Bearer ${accessToken}`,
                    'X-Session-ID': sessionId,
                    'Idempotency-Key': idempotencyKey,
                    'Content-Type': 'application/json'
                } 
            }
        );
    }

    /**
     * Select an offer with specific amount
     */
    public selectOffer(
        offerId: string,
        amount: number,
        accessToken: string,
        sessionId: string,
        dealPrivateId: string,
        dealPublicId: string | null,
        idempotencyKey: string = `select-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`
    ): Promise<AxiosResponse<any>> {
        const url = dealPublicId 
            ? `/deal-service/api/deals/${offerId}/select?dealPrivateId=${dealPrivateId}&dealPublicId=${dealPublicId}`
            : `/deal-service/api/deals/${offerId}/select?dealPrivateId=${dealPrivateId}`;
        
        return this.api.post(
            url,
            { amount },
            { 
                headers: { 
                    'Authorization': `Bearer ${accessToken}`,
                    'X-Session-ID': sessionId,
                    'Idempotency-Key': idempotencyKey,
                    'Content-Type': 'application/json'
                } 
            }
        );
    }
}

export default new OffersService();
